import { render, staticRenderFns } from "./SolicitudClienteIndex.vue?vue&type=template&id=018c0061&"
import script from "./SolicitudClienteIndex.vue?vue&type=script&lang=js&"
export * from "./SolicitudClienteIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCol,VExpansionPanelContent,VPagination})
